/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

import $ from 'jquery';

import moment from 'moment-timezone';
import Vue from 'vue';
import {PaginationPlugin, TablePlugin} from 'bootstrap-vue';
import {InputGroupPlugin, FormInputPlugin, ButtonPlugin} from 'bootstrap-vue';
import VTooltip from 'v-tooltip';
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
// noinspection ES6UnusedImports
import flatpickr from 'flatpickr';
/**
 * Set up php language files for Javascript, grab locale from meta element.
 */
import Lang from 'lang.js';
import languages from './languages';


Vue.use(TablePlugin);
Vue.use(PaginationPlugin);

Vue.use(InputGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(ButtonPlugin);

// MomentJS (time)
window.moment = moment;

// Get all php lang files as a lang.js compatible object.
const messages = languages.get();

window.Lang = new Lang({});
window.Lang.setMessages(messages);

Vue.prototype.Lang = window.Lang;
Vue.filter('lang', function (key, replacements) {
  return window.Lang.get(key, replacements);
});

Vue.filter('formatCurrency', (amount, currency, locale) => {
  const loc = typeof locale === 'undefined' ? 'sv-SE' : locale;

  let style = {};
  if (currency) {
    style = {style: 'currency', currency: currency.toUpperCase()};
  }

  return new Intl.NumberFormat(loc, style).format(amount);
});

// Read meta element for name.
const metaLocale = document.querySelector('meta[name="locale"]');
window.Lang.setLocale(metaLocale && metaLocale.getAttribute('content') || 'en');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.config.ignoredElements = [
  'ovideo',
];

// Avoid injection of {{ in the app
// Vue would otherwise interpolate {{ }} anywhere
const DELIMITER_PATCH = {
  replace() {
    return '^(?!.).'
  }
};
Vue.mixin({
  delimiters: [DELIMITER_PATCH, DELIMITER_PATCH]
});

window.Vue = Vue;

//allow for __() lang in js methods
window.__ = function (key, replacements) {
  return window.Lang.get(key, replacements);
};

// Register available components
function registerComponents(components, namespaces = []) {
  components.keys().forEach(filePath => {
    const componentConfig = components(filePath);

    let fileParts = filePath.split('/');
    let componentName = upperFirst(camelCase(fileParts.pop().replace(/\.\w+$/, '')));
    const namespace = fileParts.pop();

    if (namespaces.includes(namespace)) {
      componentName = upperFirst(camelCase(namespace)) + componentName;
    }
    Vue.component(componentName, componentConfig.default || componentConfig);
  });
}

//use v-tooltip
Vue.use(VTooltip, {
  defaultClass: 'v-tooltip',
  defaultTemplate: '<div class="v-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  popover: {
    defaultBaseClass: 'v-tooltip v-popover',
    defaultTrigger: 'hover focus',
  },
});

// Passport components are namespaced (passport-clients) etc
const namespaces = ['passport'];
registerComponents(require.context('.', true, /\.vue$/i), namespaces);

let app = new Vue({
  el: '#main-wrapper',
});

window.app = app;
